<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'ADD'" @close="closeModal" :title="$t('ADD_INVITATION')">
            <add-invitation-modal @cancel="closeModal" @save="closeModal('getData')" :title="''"/>
        </modal>
        <modal :showDialog="activeModal === 'EDIT'" @close="closeModal" :title="$t('EDIT_INVITATION')">
            <add-invitation-modal @cancel="closeModal" @save="closeModal('getData')" :userObject="activeInvitation" :title="''"/>
        </modal>
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DELETE_INVITATION')">
          <pin-modal @cancel="closeModal" :text="actionText" @confirm="closeModal('getData')" :invitationId="activeInvitation != null ? activeInvitation.id : ''"></pin-modal>
        </modal>
        <modal :showDialog="activeModal === 'ENABLE'" @close="closeModal" :title="$t('ENABLE_INVITATION')">
          <question-confirm @cancel="closeModal" @confirm="enableInvitation" :text="actionText" :alternativeDeleteText="'AreYouSureEnable'"></question-confirm>
        </modal>
        <modal :showDialog="activeModal === 'DISABLE'" @close="closeModal" :title="$t('DISABLE_INVITATION')">
          <question-confirm @cancel="closeModal" @confirm="disableInvitation" :text="actionText" :alternativeDeleteText="'AreYouSureDisable'"></question-confirm>
        </modal>
		<div>
			<div class="max-grid">
				<ejs-grid ref="grid" height='100%' width='100%' :toolbar='$store.getters.isAdmin ? toolbar : null' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="invitations" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :sortSettings="sortOptions" :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" >
					<e-columns>
						<e-column field='email' :headerText="$t('Email')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='fullName' :headerText="$t('Name')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='expirationDate' :headerText="$t('ExpirationDate')" textAlign='Left' type="date" :format="dateTimeFormatOptions" :customAttributes="customAttributes" :filter="filterCheckBox" width="200px"></e-column>
						<e-column field='systemNames' :sortComparer='sortComparer' :headerText="$t('AccessToSystem')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='systemGroups' :headerText="$t('SystemGroups')" textAlign='Left' :template="groupsAccessTemplate" :customAttributes="customAttributes"></e-column>
						<e-column v-if="$store.getters.isAdmin" field='id' headerText="" width="150px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
    </div>
</template>

<script>
import Button from '@/components/Button'
import { getInvitations, enableInvitations, disableInvitations } from '@api'

import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Modal from '@/components/Modal.vue'
import Vue from "vue";
import AddInvitationModal from '../../components/Users/AddInvitationModal.vue';
import PinModal from '@/components/Users/PinModal.vue';
import QuestionConfirm from '@/components/QuestionConfirm.vue'

export let context = null

export default {
    props: {
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    components: {
        Button,
        Modal,
        AddInvitationModal,
        PinModal,
        QuestionConfirm,
    },
    data() {
        return {
            invitations: [],
            activeModal: 'NONE',

            pageSettings: { pageSize: 100, pageSizes: [10,25,50,100] },
            toolbar: [
                { text: this.$t('Invitations'), align: 'Left', id: 'table-title'},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('AddInvitation'), tooltipText: this.$t('AddInvitation'), prefixIcon: 'e-add', id: 'add-invitation', align: 'Right' },
                'Search'
            ],
            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu',
            },
            filterCheckBox: {
                type: 'CheckBox',
            },
            sortOptions: {
                columns: [
                    { field: 'role', direction: 'Ascending' }
                ]
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'dateTime' },
            customAttributes : {class: 'customcss'},
            activeInvitation: {},
            actionText: '',
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('EDIT')" content="${context.$t('Edit')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>
                                </div>
                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" content="${context.$t('Delete')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                                <div v-if="data.isDisabled" class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('ENABLE')" content="${context.$t('Enable')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                                <div v-if="!data.isDisabled" class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('DISABLE')" content="${context.$t('Disable')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg fill="#346F8B" width="18" height="18" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="m 11.25,6.996106 q 0,-1.253731 -0.67969,-2.297209 L 4.67969,10.562622 Q 5.75,11.255678 7,11.255678 q 0.86719,0 1.65234,-0.338741 Q 9.4375,10.578196 10.00781,10.009734 10.57812,9.441272 10.91406,8.650876 11.25,7.86048 11.25,6.996106 z M 3.44531,9.324465 9.34375,3.452952 Q 8.28906,2.744322 7,2.744322 q -1.15625,0 -2.13281,0.568462 Q 3.89062,3.881246 3.32031,4.862427 2.75,5.843608 2.75,6.996106 q 0,1.261519 0.69531,2.328359 z M 13,6.996106 q 0,1.222583 -0.47656,2.336146 -0.47656,1.113562 -1.27735,1.915639 -0.80078,0.802077 -1.91406,1.277093 Q 8.21875,13 7,13 5.78125,13 4.66797,12.524984 3.55469,12.049968 2.75391,11.247891 1.953125,10.445814 1.476562,9.332252 1,8.218689 1,6.996106 1,5.773523 1.476562,4.663855 1.953125,3.554186 2.75391,2.752109 3.55469,1.950032 4.66797,1.475016 5.78125,1 7,1 8.21875,1 9.33203,1.475016 10.44531,1.950032 11.24609,2.752109 12.04688,3.554186 12.52344,4.663855 13,5.773523 13,6.996106 z"/></svg>
                                </div>
                            </div>

                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch(mode){
                                    case 'EDIT':
                                        context.openModal(this.data, 'EDIT')
                                        break;
                                    case 'DELETE':
                                        context.openModal(this.data, 'DELETE')
                                        context.actionText = this.$t('DeleteInvitation-').format(this.data.email);
                                        break;
                                    case 'ENABLE':
                                        context.openModal(this.data, 'ENABLE')
                                        context.actionText = this.$t('EnableInvitation-').format(this.data.email);
                                        break;
                                    case 'DISABLE':
                                        context.openModal(this.data, 'DISABLE')
                                        context.actionText = this.$t('DisableInvitation-').format(this.data.email);
                                        break;
                                }
                            }
                        }
                    })
                }
            },
            groupsAccessTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden !important;">{{ accesses }}</div>
                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        computed: {
                            accesses() {
                                var str = ""
                                for(let i = 0; i < this.data.systemGroups.length; i++){
                                    str += this.data.systemGroups[i].name + ", "
                                }
                                if(str.endsWith(", ")){
                                    str = str.substring(0, str.length - 2);
                                }
                                return str;
                            }
                        },
                        mounted() {
                        }
                    })
                }
            },
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            let result = await getInvitations();
            result.forEach(e => {
                var str = ""
                for(let i = 0; i < e.systems.length; i++){
                    str += e.systems[i].name + ", "
                }
                if(str.endsWith(", ")){
                    str = str.substring(0, str.length - 2);
                }
                e.systemNames = str
            })

            this.invitations = result.sort(this.sortSystemsByName)
            this.$store.dispatch('set_loading', false)
        },

        toolbarClick: function(args) {
            switch(args.item.id){
                case 'add-invitation':
                    this.openModal(null, 'ADD')
                    break;
            }
        },
        openModal(item, mode) {
            this.activeInvitation = item
            // this.deleteText = 'Delete ' + (this.activeUser != null ? this.activeUser.fullName : '');
            this.activeModal = mode
        },
        closeModal(mode){
            // this.activeUser = null
            this.activeInvitation = null;
            this.actionText = "";
            this.activeModal = 'NONE';
            if(mode == 'getData')
                this.getData()
        },
        dataBound: function() {
            this.$refs.grid.autoFitColumns();
        },
        async enableInvitation() {
          await enableInvitations([this.activeInvitation.id]);
          this.closeModal('getData')
        },
        async disableInvitation() {
          await disableInvitations([this.activeInvitation.id]);
          this.closeModal('getData')
        },
        sortComparer: function(reference, comparer) {
			return reference.localeCompare(comparer, undefined, {
              numeric: true,
              sensitivity: 'base'
            });
		},
        sortSystemsByName(a, b){
			return (a.systemNames.localeCompare(b.systemNames, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
    },
    mounted: async function () {
        await this.getData();

        context = this
    },
}
</script>

<style scoped>
    .table {
        border-top: none;
        border-left: none;
        border-right: none;
    }

    .table tbody{
        border-left: 1px solid #A3D4E0;
        border-right: 1px solid #A3D4E0;
    }
    .e-grid .e-headercell.customcss{
        padding:0 5px 0 5px;
    }

    .e-grid .e-headercell .e-headercelldiv{
        padding-right:5px;
    }
    .e-gridchkbox.customcss .e-checkbox-wrapper{
        vertical-align: middle;
    }
</style>

<style>
    .tippy-tooltip.customTheme-theme {
      background-color: #346F8B;
    }

    .tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
      border-left: 8px solid #346F8B;
    }
</style>



// WEBPACK FOOTER //
// src/views/Users/UsersInvitations.vue